module.exports = __webpack_public_path__ + "static/media/HCMM828.31929efe.jpg";